<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { t } from 'svelte-i18n';
    import { fetchCobradores, saveCobrador, removeCobrador, searchCobradores, subscribeToCobradores, unsubscribeFromCobradores } from '../controllers/cobradorController.js';
    import { fetchSucursales } from '../controllers/sucursalController.js';


    // Configuración de las columnas para la tabla de cobradores
    let cobradorColumns = [
        { label: 'DPI', field: 'dpi', type: 'number' },
        { label: 'NIT', field: 'nit', type: 'number' },
        { label: $t('fields.name'), field: 'nombre', type: 'text' },
        { label: $t('fields.address'), field: 'direccion', type: 'text' },
        { label: $t('fields.phone'), field: 'tel', type: 'number' },
        { label: $t('fields.maritalStatus'), field: 'estado_civil', type: 'text' },
        { label: 'Comision', field: 'comision', type: 'number' },
        { label: 'Sucursal', field: 'sucursal', type: 'text' },
        { label: $t('fields.state'), field: 'sta', type: 'bool' },
        { label: 'Email', field: 'email', type: 'text' },
    ];

    // Estructura del nuevo objeto Cobrador
    let newCobrador = {
        nombre: '',
        telefono: '',
        email: '',
        sta: true,
    };

    // Configuración de los campos para la edición de cobradores
    let editColumns = [
        { label: 'Sucursal', key: 'sucursal', type: 'select', required: true, fetchOptions: { key: 'id', value: 'descrip' }, options: [] },

        { label: 'DPI', key: 'dpi', type: 'number', required: true },
        { label: 'NIT', key: 'nit', type: 'number', required: true },
        { label: $t('fields.name'), key: 'nombre', type: 'text', required: true },
        { label: $t('fields.address'), key: 'direccion', type: 'text', required: true },
        { label: $t('fields.phone'), key: 'tel', type: 'number', required: true },
        { label: $t('fields.maritalStatus'), key: 'estado_civil', type: 'select', required: true, options: [
          { key: 'soltero', value: 'Soltero' },
          { key: 'casado', value: 'Casado' },
          { key: 'viudo', value: 'Viudo' },
          { key: 'divorciado', value: 'Divorciado' },
          { key: 'unido', value: 'Unido' }
        ]
      },

        { label: 'Comision', key: 'comision', type: 'number', required: true },
        { label: $t('fields.state'), key: 'sta', type: 'checkbox', required: true },
        { label: 'Email', key: 'email', type: 'email', required: false },

    ];

    // Función para cargar datos adicionales si es necesario
    let sucursalOptions = [];

    // Función para cargar y transformar sucursales
    async function loadSucursales() {
        try {
            const fetchedSucursales = await fetchSucursales();

            if (Array.isArray(fetchedSucursales.sucursal)) {
                sucursalOptions = fetchedSucursales.sucursal.map(e => ({
                    key: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.key],
                    value: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.value],
                }));

                // Asigna las opciones transformadas a las columnas editables
                editColumns.find(column => column.key === 'sucursal').options = sucursalOptions;
            } else {
                console.error('Se esperaba un array de sucursales, pero se obtuvo:', fetchedSucursales);
            }
        } catch (error) {
            console.error('Error al cargar las sucursales:', error);
        }
    }

    // Cargar las sucursales al montar el componente
    onMount(() => {
        loadSucursales();
    });
</script>

<CRUD 
    title={$t('entities.cobradores')}
    entityName="cobrador"
    newEntity={newCobrador}
    columns={cobradorColumns}
    fetchEntities={fetchCobradores}
    saveEntity={saveCobrador}
    removeEntity={removeCobrador}
    searchEntities={searchCobradores}
    subscribeToChanges={subscribeToCobradores}
    unsubscribeFromChanges={unsubscribeFromCobradores}
    editColumns={editColumns}
/>